export const NAME = 'personnel'
export const LABEL = 'Personnel'
export const PATH = `/${NAME}/`
export const FORM = 'Personnel'

export const subForms = [
  {
    id: 1,
    label: 'Personnel',
    path: '/personnel/',
    alternatePath: '/users/',
    patch: true,
    configName: 'personnel'
  },
  {
    id: 2,
    label: 'Role & Status',
    path: '/personnel/roles/',
    configName: 'roles',
    dataFunctionName: 'getRolesData'
  },
  {
    id: 3,
    label: 'Vettings',
    path: '/personnel/vettings/',
    configName: 'vettings',
    dataFunctionName: 'getVettingsData'
  },
  {
    id: 4,
    label: 'Trainings',
    path: '/personnel/trainings/',
    configName: 'trainings',
    alternatePath: '/personneltrainings/',
    dataFunctionName: 'getTrainingsData'
  },
  {
    id: 5,
    label: 'Supervision',
    path: '/personnel/supervisions/',
    configName: 'supervisions',
    dataFunctionName: 'getSupervisionsData'
  }
]



// WEBPACK FOOTER //
// ./src/personnel/constants.js